<div class="row mb-2">
  <div class="col-12">
    <div class="p-2 bg-primary" style="border-radius: 4px;">
      {{'AGENT_MAP'|translate}} : {{'COMPANY'|translate}}
      <span *ngFor="let line of currentAgent?.upline?.split('|')">
        <span *ngIf="line" class="ms-1">
          / {{line}}
        </span>
      </span>
      <span class="ms-1">
        / {{currentAgent?.agent_name}}
      </span>
    </div>
  </div>
</div>
